import offlineimage from "./offlineimage.jpg"
import banner_image from "./banner_image.png"
import company_logo from "./company_logo.png"
import image_avatar from "./image_avatar.png"
import contact_blog_img from "./contact_blog_img.png"
import Gmail_Icon from "./Gmail_Icon.png"
import Instagram_icon from "./Instagram_icon.png"
import YouTube_Logo from "./YouTube_Logo.png"
import footer_insta_icon from "./footer_insta_icon.png"
import footer_youtube_icon from "./footer_youtube_icon.png"
import footer_linkedin_icon from "./footer_linkedin_icon.png"
import not_found_blog_img from "./not_found_blog_img.png"
import chatbot_icon from "./chatbot_icon.png"
import ojb_logo from "./ojb_logo.png"

export const assets = {
    offlineimage,
    banner_image,
    company_logo,
    image_avatar,
    contact_blog_img,
    Gmail_Icon,
    Instagram_icon,
    YouTube_Logo,
    footer_insta_icon,
    footer_youtube_icon,
    footer_linkedin_icon,
    not_found_blog_img,
    chatbot_icon,
    ojb_logo
}